import { measuresEndpoints } from "@omega/omp-api";
import type { RequestConfig } from "@app/config/axios/http";
import { ompTransport } from "@src/api/ompTransport";
import type { ApiMeasure, ApiMeasureFilter } from "./types";

/**
 * Транспортный слой OMP — единицы измерения.
 * Контракт и wire-формат — из пакета `@omega/omp-api`.
 */
export const measureApi = {
    /**
     * Загружает единицы измерения по фильтру.
     */
    load: async (params: { flt?: ApiMeasureFilter }, config?: RequestConfig): Promise<ApiMeasure[]> => {
        return measuresEndpoints.loadByFilter.call(ompTransport, params.flt ?? {}, config);
    },
} as const;
